import React, { useContext, useEffect, useMemo, useState } from "react";
import { Avatar, Button, Col, Dropdown, Input, List, Modal, Row, Tabs, Tag } from "antd";
import Cmenu from "@/component/Menu";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import Participant from "./Participant";
import { eventEmitter } from "@/hooks/use-rtc";
import { conference } from "@/api";
import { MeetingContext } from "@/pages/Meeting";
import styled from "styled-components";
import { AnyType, BoolType, Commond, Message, ParticipantType, RoleCode, TerminalType } from "@/types";
import style from "./style.module.scss";
import { useAuth } from "@/component/Auth";
import { storage } from "@/util";
import { METTINGPAGE_SAVED_MEETING_INFO } from "@/config/const";
import * as meetingtool from "../mtools";
import ChatComponent from "./ChatComponent";
import { manageUser } from "@/api/conference";
import { useMqtt } from "@/hooks/use-mqtt";
import { Member } from "@/pages/Meeting/Participants/Member";
import AiRecord from "@/pages/Meeting/Participants/AiRecord";
import ee from "@/util/event";

const CloseContainer = styled.div`
  position: absolute;
  width: 20px;
  height: 20px;
  right: 15px;
  top: 15px;
  font-size: 20px;
  cursor: pointer;
  .scrollable-list {
  max-height: 300px; /* 或者其他你需要的高度 */
  overflow-y: auto;  /* 当内容溢出时显示垂直滚动条 */
}
`;

interface ParticipantsProps {
  onParticipantsClose: () => void;
  messageList:Message[];
}

const Participants: React.FC<ParticipantsProps> = ({ onParticipantsClose,messageList }) => {
  const [keyword, setKeyword] = useState("");
  // const {setParticipants } = useContext(RtcContext);

  const [showApplyTobeHostButton, setShowApplyTobeHostButton] = useState(false);
  const [isPasswordDialogOpen, setIsPasswordDialogOpen] = useState(false);
  const [passwordValue, setPasswordValue] = useState("");
  const [terminals, setTerminals] = useState<TerminalType[]>([]);
  const [pageNum, setPageNum] = React.useState(1);
  const [pageSize, setPageSize] = React.useState(15);
  const [activeTabKey, setActiveTabKey] = useState("1");

  const [userList, setUsers] = React.useState<Array<AnyType>>([]);

  const { publish, setCallback } = useMqtt()

  useEffect(() => {
    const openAiRecord = () => {
      setActiveTabKey("5");
    };
    ee.on("openAiRecord", openAiRecord);
    return () => {
      ee.off("openAiRecord", openAiRecord);
    };
  }, []);

  useEffect(() => {
    if (activeTabKey === "1" && userList?.length > 0) {
      setActiveTabKey("4");
    } else if (activeTabKey === "4" && userList?.length === 0) {
      setActiveTabKey("1");
    }
  }, [activeTabKey, userList?.length]);

  let {
    participants,
    displayParticipants,
    isMonitorMode,
    conference: conf,
    updateConference,
    setParticipants
  } = useContext(MeetingContext);
  //设法更新上下文里面的 participants
  participants = displayParticipants.filter((d: any) => !d.share);
  //console.log("participants:::", participants);
  const showPasswordInputDialog = (bShow: boolean) => {
    setIsPasswordDialogOpen(bShow);

    // setShowApplyTobeHostButton(false);
  };

  const handleShowPasswordInputDialogOk = async () => {
    //获取到password,直接再调用加会接口加入会议
    //比对主持人密码
    if (conference.compareHostPwd(conf.conferenceNo, passwordValue,
      {
        "X-Conference-No": conf.conferenceNo,
        "X-Channel-Token": conf["X-Channel-Token"],
        "X-Conference-Token": conf["X-Conference-Token"],
      })) {
      //成为主持人 compareHostPwd

      conference.conferenceControl(
        {
          // command: Commond.applyHostPermission,
          command: Commond.grant,
          metadata: "",
          seq: "",
          room: conf.roomId,
          from: fromPeer
        },
        {
          "X-Conference-No": conf.conferenceNo,
          "X-Channel-Token": conf["X-Channel-Token"],
          "X-Conference-Token": conf["X-Conference-Token"],
        }
      );
      setShowApplyTobeHostButton(false);
    }
    setIsPasswordDialogOpen(false);

  };

  const handleShowPasswordInputDialogCancel = () => {
    setIsPasswordDialogOpen(false);
  };

  const passwordValueChange = (e: any) => setPasswordValue(e.target.value);

  const auth = useAuth();
  const { loginfo } = auth;
  const { userId } = loginfo;
  const fromPeer = {
    peerid: userId,
    deviceid: 8,
  };
  
  React.useEffect(() => {
    eventEmitter.on('automaticNewHostGrant', (peerid, fromid,) => {
      // 处理参数
      console.log("自动推举新主持人 is!!!!!!!", peerid)
      console.log("qian主持人 is!!!!!!!", fromid)
      // updateParticipants
      // setParticipants(participants)
      //refresh participants 
      console.log("participants amount is!!!!!!!", participants)
      // refreshParticipants()
      participants.forEach((item: any) => {

        console.log("item.peerid is!!!!!!!", item.peerId)
        console.log(" peerid is!!!!!!!", peerid)

        if (item.peerId === peerid) {
          // item.isHost = true;
          // item.roleCode = 20

          console.log(" conference is!!!!!!!", conference)

          setParticipants((participants: ParticipantType[]) => {
            // 在这里创建一个新的participants数组,专门解决离会主持人不显示问题
            let newParticipants = participants.map((participant: ParticipantType) => {
              if (participant.peerId === peerid) {
                console.log("participant.peerId === peerid is!!!!!!!", peerid)
                return {
                  ...participant,
                  isHost: true,
                  roleCode: 20,

                };
              } else {
                return {
                  ...participant,
                  isHost: false,
                  roleCode: 0,
                };
              }

            });

            // if (newParticipants.length === 1) {
            //   newParticipants[0].isHost = true;
            //   newParticipants[0].roleCode = 20;
            // }
            return newParticipants;
          });
        } else {
          item.isHost = false;
          item.roleCode = 0
        }
      })



    });
  }, [])
  React.useEffect(() => {
    let mounted = true;
    const handleHostLeaveMeeting = () => {
      setShowApplyTobeHostButton(true);
    };

    eventEmitter.on('hostLeaveMeeting', handleHostLeaveMeeting);
    const loadTerminalList = async () => {
      const params: AnyType = {
        pageSize: 200,
        pageNum: 1,
      };
      try {
        const res: any = await conference.getTerminalList(params);
        if (mounted) {
          setTerminals(res.rows || []);
        }
      } catch (error) {
        console.error("loadTerminalList error:", error);
      }
    };

    //定时获取呼叫状态
    // const timer = setInterval(() => {
    //   conference.getTerminalList().then((res: any) => {
    //     //console.log("终端列表 is!!!!!!!", res)
    //     setTerminals(res.rows);
    //   });
    // }, 1000);

    const init = async () => {
      try {
        const res: any = await manageUser({ conferenceNo: conf.conferenceNo });
        if (mounted) {
          setUsers((res.data || []).sort((a: any, b: any) => Number(b.online) - Number(a.online)));
        }
      } catch (error) {
        console.error("manageUser error:", error);
      }
    };

    loadTerminalList();
    init();
    const timer = setInterval(() => {
      loadTerminalList();
      init();
    }, 2000);

    setCallback(Commond.otherLeaveRoom, () => {
      setTimeout(() => {
        void init();
      }, 200);
    });
    setCallback(Commond.otherJoinRoom, () => {
      void init();
    });

    // 在组件卸载时移除事件监听器
    return () => {
      mounted = false;
      eventEmitter.off('hostLeaveMeeting', handleHostLeaveMeeting);
      setCallback(Commond.otherLeaveRoom, () => undefined);
      setCallback(Commond.otherJoinRoom, () => undefined);
      clearInterval(timer);
    };
  }, []);
  const mergedUserList = useMemo(() => {
    if (!userList?.length) return [];
    const terminalKeyMap = new Map<string, AnyType>();
    terminals.forEach((t: AnyType) => {
      if (t.userId !== undefined && t.userId !== null) {
        terminalKeyMap.set(String(t.userId), t);
      }
    });

    const displayUsers = isMonitorMode
      ? userList.filter((u: AnyType) => String(u.userId) !== String(userId))
      : userList;

    return displayUsers.map((u: AnyType) => {
      const merged = terminalKeyMap.get(String(u.userId));
      return merged ? { ...u, ...merged, nickname: u.nickname || merged.name } : u;
    });
  }, [isMonitorMode, terminals, userId, userList]);
  const muteAll = () => {
    // conference.conferenceControl(
    //   {
    //     command: Commond.allForceMute,
    //     metadata: "",
    //     seq: "",
    //     room: conf.roomId,
    //     // to: toPeer,
    //     from: fromPeer,
    //   },
    //   {
    //     "X-Conference-No": conf.conferenceNo,
    //     "X-Channel-Token": conf["X-Channel-Token"],
    //     "X-Conference-Token": conf["X-Conference-Token"],
    //   }
    // );

    publish({
      command: Commond.allForceMute,
      data: { operatorPeerId: `${conf.roomId}_${conf.userId}` },
    })
  };

  const unmuteAll = () => {
    // conference.conferenceControl(
    //   {
    //     command: Commond.allUnMute,
    //     metadata: "",
    //     seq: "",
    //     room: conf.roomId,
    //     // to: toPeer,
    //     from: fromPeer,
    //   },
    //   {
    //     "X-Conference-No": conf.conferenceNo,
    //     "X-Channel-Token": conf["X-Channel-Token"],
    //     "X-Conference-Token": conf["X-Conference-Token"],
    //   }
    // );

    publish({
      command: Commond.allUnMute,
      data: { operatorPeerId: `${conf.roomId}_${conf.userId}` },
    })
  };

  const allActions = async (command: Commond) => {
    await conference.conferenceControl(
      {
        command,
        metadata: "",
        seq: "",
        room: conf.roomId,
        // to: toPeer,
        from: fromPeer,
      },
      {
        "X-Conference-No": conf.conferenceNo,
        "X-Channel-Token": conf["X-Channel-Token"],
        "X-Conference-Token": conf["X-Conference-Token"],
      }
    );
  };

  let menuIt: Array<string> = [];
  if (conf.lockedState) menuIt = [...menuIt, "lock"];

  if (conf.muteJoinMetting) menuIt = [...menuIt, "mute"];
  if (conf.allowSelfUnmute) menuIt = [...menuIt, "unMute"];
  if (conf.playTips) menuIt = [...menuIt, "tips"];

  const [menuSelected, setMenuSelected] = React.useState<Array<string>>(menuIt);

  const menuItems = [
    // { k: "lock", v: "锁定会议" },
    // { k: "mute", v: "成员入会时静音" },
    // { k: "unMute", v: "允许成员自我解除静音" },
    // { k: "tips", v: "成员进入时播放提示音" },
    // { k: "hand", v: "全体停止举手", c: true },
    { k: Commond.allTurnOffVideo, v: "全员关闭摄像头", c: true },
    { k: Commond.allTurnOnVideo, v: "全员开启摄像头", c: true },
  ];

  const menuSelectHandler = (
    k: string,
    checked: boolean,
    arr: Array<string>
  ) => {
    let aconf = conf;
    if (k === "lock" && checked) {
      allActions(Commond.lockConference);
      aconf = { ...conf, lockedState: BoolType.yes };
    }
    if (k === "lock" && !checked) {
      allActions(Commond.unLockConference);
      aconf = { ...conf, lockedState: BoolType.no };
    }

    if (k === "mute" && checked) {
      allActions(Commond.openMuteJoinMeeting);
      aconf = { ...conf, muteJoinMetting: BoolType.yes };
    }
    if (k === "mute" && !checked) {
      allActions(Commond.closeMuteJoinMeeting);
      aconf = { ...conf, muteJoinMetting: BoolType.no };
    }

    if (k === "unMute" && checked) {
      allActions(Commond.allowSelfUnmute);
      aconf = { ...conf, allowSelfUnmute: BoolType.yes };
    }
    if (k === "unMute" && !checked) {
      allActions(Commond.forbidSelfUnmute);
      aconf = { ...conf, allowSelfUnmute: BoolType.no };
    }

    if (k === "tips" && checked) {
      allActions(Commond.openPlayTips);
      aconf = { ...conf, playTips: BoolType.yes };
    }
    if (k === "tips" && !checked) {
      allActions(Commond.closePlayTips);
      aconf = { ...conf, playTips: BoolType.no };
    }

    if (k === "hand") {
      allActions(Commond.allHandsDown);
    }

    if (k !== "hand") {
      updateConference(aconf);
      storage.save(METTINGPAGE_SAVED_MEETING_INFO, aconf);
    }

    if (k === Commond.allTurnOffVideo) {
      publish({
        command: Commond.allTurnOffVideo,
        data: { operatorPeerId: `${conf.roomId}_${conf.userId}` },
      });
    }

    if (k === Commond.allTurnOnVideo) {
      publish({
        command: Commond.allTurnOnVideo,
        data: { operatorPeerId: `${conf.roomId}_${conf.userId}` },
      });
    }

    setMenuSelected([...arr]);
  };

  const menu = React.useMemo(
    () => (
      <Cmenu
        items={menuItems}
        onSelect={menuSelectHandler}
        selectedItems={menuSelected}
      ></Cmenu>
    ),
    [menuSelectHandler, menuSelected]
  );

  const isManage = meetingtool.selfIsManage(conf, participants);

  return (
    <div className={`${style.container} pt20 relative`}>
      <CloseContainer>
        <CloseOutlined onClick={onParticipantsClose} />
      </CloseContainer>
      <div className={style.search}>
        <h2>成员..</h2>
        <Row gutter={8}>
          <Col flex="1 1 100px">
            <Input
              prefix={<SearchOutlined />}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索/邀请"
            />
          </Col>
          {/* <Col flex="0 1 40px">
            <Tooltip title="分享">
              <Button icon={<Icon type="icon-share" />} />
            </Tooltip>
          </Col> */}
        </Row>
      </div>
      <div className={style.tabsContainer}>
        <Tabs activeKey={activeTabKey} onChange={setActiveTabKey}>
          {userList?.length === 0 && <Tabs.TabPane tab={`会议中(${participants.length})`} key="1">
            <List itemLayout="horizontal">
              {/* {participants
                .filter((d: any) => !keyword || d.peerName.includes(keyword))
                .map((d: any, i: number) => (
                  
                  <Participant key={i} participant={d} />
                ))} */}
              {participants
                .filter((d: ParticipantType) => !keyword || d.peerName.includes(keyword))
                .map((d: ParticipantType, i: number) => {
                  // 如果participants只有一项，将isHost设为false
                  // if (participants.length === 1) {
                  //   d.isHost = true;
                  //   d.roleCode = 20;
                  // }

                  return <Participant key={i} participant={d} />;
                })}
            </List>
          </Tabs.TabPane>}

          {mergedUserList?.length > 0 &&<Tabs.TabPane tab={`会议成员(${mergedUserList?.length})`} key="4">
            <div className="scrollable-list">
              <List itemLayout="horizontal">
                {mergedUserList.map((d: AnyType) => (<Member key={`${d.userId}_${d.platformType}_${d.callUrl || d.name || ""}`} user={d}></Member>))}
              </List>
            </div>
          </Tabs.TabPane>}
          {/* <Tabs.TabPane tab={`终端设备(${terminals.length})`} key="2">
  <div className="scrollable-list">
    <List itemLayout="horizontal">
      {terminals && terminals.length > 0 ? (
        terminals
          .filter((d: TerminalType) => !keyword || (d.name && d.name.includes(keyword)))
          .map((d: TerminalType) => (
            <Terminal key={d.id} terminal={d} />
          ))
      ) : (
        <p>No terminals found.</p>
      )}
    </List>
  </div>
</Tabs.TabPane> */}
          <Tabs.TabPane tab="聊天" key="3">
          <ChatComponent messageList={messageList} />{/* 渲染聊天组件 */}
          </Tabs.TabPane>

          <Tabs.TabPane tab="AI纪要" key='5'>
            <AiRecord messageList={messageList}/>
          </Tabs.TabPane>
        </Tabs>
      </div>
      <div className="h45 pl10 pr10 jssb">
        <div className="fac">
          <Modal
            title="请输入主持人密码"
            width={300}
            centered
            visible={isPasswordDialogOpen}
            onOk={handleShowPasswordInputDialogOk}
            onCancel={handleShowPasswordInputDialogCancel}
            okText="申请成为主持人 "
            cancelText="取消"
          >
            <Input
              value={passwordValue}
              onChange={passwordValueChange}
              placeholder="会议密码"
            />
          </Modal>
          {showApplyTobeHostButton && (

            <Button
              block
              type="primary"
              onClick={async () => {
                showPasswordInputDialog(true);
                // 在这里处理按钮的点击事件
                // setShowApplyTobeHostButton(false);
              }}>
              申请成为主持人
            </Button>
          )}
        </div>
      </div>
      {isManage && (
        <div className="h45 pl10 pr10 jssb mb10">
          <div className="fac">

             <Button block onClick={muteAll} size="small" danger type="primary">
              全员静音
            </Button>
            <Button
              block
              onClick={unmuteAll}
              className="ml5"
              size="small"
              type="primary"
            >
              取消全员静音
            </Button>
          </div>
           <div>
            <Dropdown overlay={menu}>
              <Button block onClick={unmuteAll} className="ml5" size="small">
                更多操作
              </Button>
            </Dropdown>
          </div>
        </div>
      )}
    </div>
  );
};

export default Participants;
